import React from 'react';

import { usePathname } from 'expo-router';
import { useDragonBallTakeoverExposureEligibility } from 'features/app-takeover/hooks/use-app-takeover';
import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import { MainMenuPage } from 'features/menu/pages/main-menu-page';
import { MainMenuPageV2 } from 'features/menu/pages/main-menu-page-v2';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { useDeeplinksFlowExperiment } from 'experiments/deeplinks-flow-feature/use-deeplinks-flow-experiment';
import { useDragonBallExperiment } from 'experiments/use-dragon-ball-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { isMenuObjectDetailRoute } from 'navigation/routing/utils';
import { useMainMenuContext } from 'state/menu/main-menu';
import { routes } from 'utils/routing';

export default function MenuRoute() {
  const pathname = usePathname();
  const { isLoading: isExperimentLoading } = useDeeplinksFlowExperiment();
  // Item/combo deep links own store selection. Also wait for Amplitude so a
  // brief `/menu` paint during deeplink resolution cannot open the locator
  // before the product information modal.
  const requireStore = !isExperimentLoading && !isMenuObjectDetailRoute(pathname);

  useStoreRequired(requireStore, undefined, routes.menu);

  return <MenuInner />;
}

const MenuInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const { isActive: isDragonBallTakeoverActive } = useDragonBallTakeoverExposureEligibility();
  const { activeDayParts } = useMainMenuContext();

  useDragonBallExperiment(!isDragonBallTakeoverActive, activeDayParts);

  return <MenuTabsWrap>{enableUnifiedMenu ? <MainMenuPageV2 /> : <MainMenuPage />}</MenuTabsWrap>;
});
